module.exports = __webpack_public_path__ + "3026eb3301fe91c0f0a3bfd0799d269b.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/age-gate-bg-1024.webp
// module id = 162
// module chunks = 0